import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import "./CategoryProducts.css";
import Header from "../KalHome/Header";
import Headerads from "../KalHome/Headerads";
import Prefooterads from "../Homecomponents/Prefooterads";
import Newsletter from "../Homecomponents/Newsletter";
import Footer from "../Homecomponents/Footer";
import SocialLinks from "../Homecomponents/Sociallinks";
import Endfooter from "../Homecomponents/Endfooter";
import { wishlistUtils } from "../utils/userCartWishlistUtils";
import ProgressLoader from "../Loader/ProgressLoader";
import Superheader from "../KalHome/Superheader";
import { FaHeart, FaRegHeart } from "react-icons/fa";

const CategoryProducts = () => {
  const { CategoryID } = useParams();
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeCategory, setActiveCategory] = useState(CategoryID || "1");
  const [wishlistStatus, setWishlistStatus] = useState({});
  const [showAlert, setShowAlert] = useState(false);
  const [isSticky, setIsSticky] = useState(false);

  // Sticky header effect
  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Initialize wishlist status
  useEffect(() => {
    if (products.length > 0) {
      const initialWishlistStatus = {};

      products.forEach((product) => {
        initialWishlistStatus[product.id] = wishlistUtils.isInWishlist(
          product.id
        );
      });

      setWishlistStatus(initialWishlistStatus);
    }
  }, [products]);

  // Fetch all categories
  const fetchCategories = async () => {
    try {
      const response = await axios.get(
        "https://api.dremerz.net/api/DZ_8925_KalanjiyamEcom_Products_Category_CategoryList"
      );
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  // Fetch subcategories for active category
  const fetchSubCategories = async () => {
    try {
      const response = await axios.get(
        `https://api.dremerz.net/api/DZ_8925_KalanjiyamEcom_Products_SubCategory_SubCategoryList?categoryId=${activeCategory}`
      );
      setSubCategories(response.data);
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    }
  };

  // Fetch products for active category
  const fetchProducts = async () => {
    try {
      const response = await axios.get(
        `https://api.dremerz.net/api/DZ_8925_KalanjiyamEcom_Products_AllProducts_ProductsList?categoryId=${activeCategory}`
      );
      setProducts(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching products:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {
    if (activeCategory) {
      setLoading(true);
      fetchSubCategories();
      fetchProducts();
    }
  }, [activeCategory]);

  // Handle category change
  const handleCategoryChange = (categoryId) => {
    setActiveCategory(categoryId);
    navigate(`/${categoryId}`);
  };

  // Handle See All click
  const handleSeeAllClick = (subCategoryId, subCategoryName) => {
    navigate(`/seeall/${subCategoryId}`, {
      state: {
        subCategoryName,
        categoryId: activeCategory,
      },
    });
  };

  // Wishlist handlers
  const handleWishlistToggle = async (productId) => {
    if (wishlistStatus[productId]) {
      const success = await wishlistUtils.removeFromWishlist(productId);
      if (success) {
        setWishlistStatus((prev) => ({
          ...prev,
          [productId]: false,
        }));
      }
    } else {
      const success = await wishlistUtils.addToWishlist(productId);
      if (success) {
        setWishlistStatus((prev) => ({
          ...prev,
          [productId]: true,
        }));
      } else {
        setShowAlert(true);
      }
    }
  };

  // Handle product click
  const handleProductClick = (product) => {
    navigate(`/product/${product.id}`, { state: { product } });
  };

  // Group products by subcategory
  const productsBySubCategory = subCategories.reduce((acc, subCategory) => {
    const subCategoryProducts = products.filter(
      (product) => product.subCategoryId === subCategory.id
    );
    if (subCategoryProducts.length > 0) {
      acc[subCategory.id] = {
        name: subCategory.subCategoryName,
        products: subCategoryProducts,
      };
    }
    return acc;
  }, {});

  if (loading) {
    return (
      <div className="category-loading">
        <ProgressLoader />
      </div>
    );
  }

  return (
    <>
      <Superheader />
      <div className={isSticky ? "header-wrapper sticky" : "header-wrapper"}>
        <Header />
      </div>
      <Headerads />
      <div className="category-products-container">
        {/* Products by Subcategory */}
        {Object.entries(productsBySubCategory).map(
          ([subCategoryId, { name, products }]) => (
            <div key={subCategoryId} className="category-subcategory-section">
              <div className="category-subcategory-header">
                <h2 className="category-subcategory-title">{name}</h2>
                <button
                  className="category-see-all-btn"
                  onClick={() => handleSeeAllClick(subCategoryId, name)}
                >
                  See All
                </button>
              </div>
              <div className="category-products-scroll-container">
                <div className="category-products-scroll">
                  {products.map((product) => (
                    <div key={product.id} className="category-product-card">
                      <div
                        className="category-product-image-container"
                        onClick={() => handleProductClick(product)}
                      >
                        <img
                          src={
                            product.productImage
                              ? `https://api.dremerz.net/uploads/${product.productImage}`
                              : "/default-product.jpg"
                          }
                          alt={product.brandName}
                          className="category-product-image"
                        />
                        {product.tags && (
                          <span className="category-product-tag">{product.tags}</span>
                        )}
                      </div>
                      <div className="category-product-info">
                        <h3 onClick={() => handleProductClick(product)}>
                          {product.brandName}
                        </h3>
                        <p className="category-product-name m-0">{product.productName}</p>
                        <div className="category-product-price">
                          <span className="category-current-price">
                            ₹{product.sellingPrice}
                          </span>
                          {product.originalPrice && (
                            <>
                              <span className="category-original-price">
                                ₹{product.originalPrice}
                              </span>
                              <span className="category-offer">
                                {" "}({Math.round(
                                  ((product.originalPrice -
                                    product.sellingPrice) /
                                    product.originalPrice) *
                                    100
                                )}
                                % OFF)
                              </span>
                            </>
                          )}
                        </div>
                        <div className="category-product-actions">
                          <button
                            className={`category-action-btn category-wishlist-btn ${
                              wishlistStatus[product.id]
                                ? "category-in-wishlist"
                                : ""
                            }`}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleWishlistToggle(product.id);
                            }}
                          >
                            {wishlistStatus[product.id] ? (
                              <FaHeart />
                            ) : (
                              <FaRegHeart />
                            )}
                            {wishlistStatus[product.id]
                              ? " Wishlisted"
                              : " Wishlist"}
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )
        )}

        {/* Login Alert Modal */}
        {showAlert && (
          <div className="category-modal-overlay">
            <div className="category-modal-content">
              <h3>Login Required</h3>
              <p>Please login to add items to your wishlist.</p>
              <div className="category-modal-actions">
                <button
                  className="category-btn-cancel"
                  onClick={() => setShowAlert(false)}
                >
                  Cancel
                </button>
                <button
                  className="category-btn-login"
                  onClick={() => navigate("/login")}
                >
                  Login
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      <Prefooterads />
      <Newsletter />
      <Footer />
      <SocialLinks />
      <Endfooter />
    </>
  );
};

export default CategoryProducts;